import React, { useEffect } from 'react';
import { Box } from '@chakra-ui/react';
import Header from '@components/molecules/Header';
import Footer from '@components/molecules/Footer';
import Menu from '@components/molecules/Menu';
import Flyout from '@components/molecules/Flyout';
import Logo from '@components/atoms/Logo';

import { dataLayerPage } from '@helpers/dataLayerPush';

export const Layout = ({ children, seo, location, showFooter = true }) => {
  useEffect(() => {
    dataLayerPage({ event: `meta_data`, seo, location });
    dataLayerPage({ event: `pageView`, seo, location });
  }, [location, seo]);
  return (
    <>
      <Header stick>
        <Logo linkTo="/" />
        <Flyout>
          <Menu />
        </Flyout>
      </Header>
      <Box as="main">{children}</Box>
      {showFooter && <Footer seo={seo} location={location} />}
    </>
  );
};
